import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
import {
	addSavingsDetailsFailure,
	addSavingsDetailsResponseChanged,
	addSavingsDetailsSuccess,
	deleteSavingsDetailsFailure,
	deleteSavingsDetailsResponseChanged,
	deleteSavingsDetailsSuccess,
	fetchAllSavingsListFailure,
	fetchAllSavingsListResponseChanged,
	fetchAllSavingsListSuccess,
	fetchSavingsDetailsFailure,
	fetchSavingsDetailsResponseChanged,
	fetchSavingsDetailsSuccess,
	getSavingsListFailure,
	getSavingsListResponseChanged,
	getSavingsListSuccess,
	updateSavingsDetailsFailure,
	updateSavingsDetailsResponseChanged,
	updateSavingsDetailsSuccess,
} from './savings.action';
import savingsActionTypes from './savings.types';
import {
	allSavingsFetch,
	savingsDetailsAdd,
	savingsDetailsDelete,
	savingsDetailsFetch,
	savingsDetailsUpdate,
	savingsListGet,
} from './savings.services';

/** *********************  START ADD SAVINGS DETAILS  ******************** */
export function* createSavings({ payload }: any) {
	try {
		const key = 'AddSavingsDetailKey';
		const {
			thriftName,
			thriftAmount,
			thriftInterest,
			thriftNoOfInstalemt,
			thriftInterestType,
			thriftInstalmentType,
			databaseName,
			companyID,
			userAccessBranchID,
			userName,
			userID,
		} = payload;
		const jsonData = {
			ThriftName: thriftName,
			ThriftAmount: thriftAmount,
			ThriftInterest: thriftInterest,
			NoOfInstalment: thriftNoOfInstalemt,
			InterestType: thriftInterestType,
			InstalmentType: thriftInstalmentType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addSavingsDetailsFailure(responseData.data));
		} else {
			yield put(addSavingsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addSavingsDetailsFailure(error));
	}
}

export function* resetAddSavingsResponse() {
	yield put(addSavingsDetailsResponseChanged());
}

export function* onCreateSavingsDetails() {
	yield takeLatest(savingsActionTypes.ADD_SAVINGS_DETAILS_START, createSavings);
}

export function* onCreateSavingsResponseReset() {
	yield takeLatest(
		savingsActionTypes.ADD_SAVINGS_DETAILS_RESPONSE_RESET,
		resetAddSavingsResponse,
	);
}
/** *********************  END ADD SAVINGS DETAILS  ******************** */

/** *********************  START UPDATE SAVINGS DETAILS  ******************** */
export function* savingsUpdate({ payload }: any) {
	try {
		const key = 'UpdateSavingsDetailsKey';
		const {
			thriftID,
			thriftName,
			thriftAmount,
			thriftInterest,
			thriftNoOfInstalemt,
			thriftInstalmentType,
			userAccessBranchID,
			userName,
			userID,
			thriftInterestType,
			companyID,
			databaseName,
		} = payload;
		const jsonData = {
			ThriftID: thriftID,
			ThriftName: thriftName,
			ThriftAmount: thriftAmount,
			ThriftInterest: thriftInterest,
			NoOfInstalment: thriftNoOfInstalemt,
			InterestType: thriftInterestType,
			InstalmentType: thriftInstalmentType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSavingsDetailsFailure(responseData.data));
		} else {
			yield put(updateSavingsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSavingsDetailsFailure(error));
	}
}

export function* resetUpdateSavingsDetailsResponse() {
	yield put(updateSavingsDetailsResponseChanged());
}

export function* onUpdateSavingsDetails() {
	yield takeLatest(savingsActionTypes.UPDATE_SAVINGS_DETAILS_START, savingsUpdate);
}

export function* onUpdateSavingsResponseReset() {
	yield takeLatest(
		savingsActionTypes.UPDATE_SAVINGS_DETAILS_RESPONSE_RESET,
		resetUpdateSavingsDetailsResponse,
	);
}
/** *********************  END UPDATE SAVINGS DETAILS ******************** */

/** *********************  START GET SAVINGS LIST  ******************** */
export function* savingsDetailsListGet({ payload }: any) {
	try {
		const key = 'GetSavingsListKey';
		const { companyID, databaseName, inputSearch, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSavingsListFailure(responseData.data));
		} else {
			yield put(getSavingsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSavingsListFailure(error));
	}
}

export function* resetGetSavingsListResponse() {
	yield put(getSavingsListResponseChanged());
}

export function* onGetSavingstListDetails() {
	yield takeLatest(savingsActionTypes.GET_SAVINGS_LIST_START, savingsDetailsListGet);
}

export function* onGetSavingsListResponseReset() {
	yield takeLatest(
		savingsActionTypes.GET_SAVINGS_LIST_RESPONSE_RESET,
		resetGetSavingsListResponse,
	);
}
/** *********************  END GET SAVINGS LIST ******************** */

/** *********************  START FETCH SAVINGS DETAILS  ******************** */
export function* fetchSavingsData({ payload }: any) {
	try {
		const key = 'FetchSavingsDetailsKey';
		const { companyID, thriftID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			ThriftID: thriftID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSavingsDetailsFailure(responseData.data));
		} else {
			yield put(fetchSavingsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSavingsDetailsFailure(error));
	}
}

export function* resetFetchSavingsDetailsResponse() {
	yield put(fetchSavingsDetailsResponseChanged());
}

export function* onFetchSavingsDetails() {
	yield takeLatest(savingsActionTypes.FETCH_SAVINGS_DETAILS_START, fetchSavingsData);
}

export function* onFetchSavingsResponseReset() {
	yield takeLatest(
		savingsActionTypes.FETCH_SAVINGS_DETAILS_RESPONSE_RESET,
		resetFetchSavingsDetailsResponse,
	);
}
/** *********************  END FETCH SAVINGS DETAILS ******************** */

/** *********************  START DELETE SAVINGS DETAILS  ******************** */
export function* savingsDelete({ payload }: any) {
	try {
		const key = 'DeleteSavingsDetailsKey';
		const {
			companyID,
			thriftID,
			thriftName,
			databaseName,
			userID,
			userAccessBranchID,
			userName,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			ThriftID: thriftID,
			ThriftName: thriftName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteSavingsDetailsFailure(responseData.data));
		} else {
			yield put(deleteSavingsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteSavingsDetailsFailure(error));
	}
}

export function* resetDeleteSavingsDetailsResponse() {
	yield put(deleteSavingsDetailsResponseChanged());
}

export function* onDeleteSavingsDetail() {
	yield takeLatest(savingsActionTypes.DELETE_SAVINGS_DETAILS_START, savingsDelete);
}

export function* onDeleteSavingsResponseReset() {
	yield takeLatest(
		savingsActionTypes.DELETE_SAVINGS_DETAILS_RESPONSE_RESET,
		resetDeleteSavingsDetailsResponse,
	);
}
/** *********************  END DELETE SAVINGS DETAILS ******************** */

/** *********************  START FETCH ALL THRIFTS LIST  ******************** */
export function* fetchAllSavingsList({ payload }: any) {
	try {
		const key = 'FetchAllSavingsKey';
		const { companyID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allSavingsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllSavingsListFailure(responseData.data));
		} else {
			yield put(fetchAllSavingsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllSavingsListFailure(error));
	}
}

export function* resetFetchAllSavingsResponse() {
	yield put(fetchAllSavingsListResponseChanged());
}

export function* onFetchAllSavingsDetails() {
	yield takeLatest(savingsActionTypes.FETCH_ALL_SAVINGS_START, fetchAllSavingsList);
}

export function* onFetchAllSavingsResponseReset() {
	yield takeLatest(
		savingsActionTypes.FETCH_ALL_SAVINGS_RESPONSE_RESET,
		resetFetchAllSavingsResponse,
	);
}
/** *********************  END FETCH ALL THRIFTS LIST ******************** */

export function* savingsMasterSaga() {
	yield all([
		call(onCreateSavingsDetails),
		call(onCreateSavingsResponseReset),
		call(onUpdateSavingsDetails),
		call(onUpdateSavingsResponseReset),
		call(onGetSavingstListDetails),
		call(onGetSavingsListResponseReset),
		call(onFetchSavingsDetails),
		call(onFetchSavingsResponseReset),
		call(onDeleteSavingsDetail),
		call(onDeleteSavingsResponseReset),
		call(onFetchAllSavingsDetails),
		call(onFetchAllSavingsResponseReset),
	]);
}
